<template>
	<span></span>
</template>

<script>
  import Noty from 'noty';

  export default {
    mounted() {
    		if(this.isMobile()){
          this.displayNotice();
        }
    },
    data() {
      return {
  		  
      };
    },
    methods: {
         
       isMobile: function() {
         if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
           return true
         } else {
           return false
         }
       },
       displayNotice: function(){
          new Noty({
            text: '<img src="/images/matilda-photo.jpg" class="w-100 rounded-circle p-5" /><div class="text-center mb-5"><div class="h3">SizzleDeck is design software that requires a desktop / laptop.</div><div class="h3">Please jump onto a bigger screen to continue setup. 🙂</div></div>',
            type: 'light',
            closeWith: [''],
            theme: 'bootstrap-v4',
            layout: 'center',
            timeout: false,
            modal: true,
          }).show();
       }

     }
  }
</script>



	        